var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 .25C5.073.25.25 5.073.25 11c0 4.735 3.072 8.74 7.33 10.15.537.1.73-.233.73-.517 0-.256-.01-.933-.015-1.83-2.98.647-3.61-1.43-3.61-1.43-.487-1.237-1.19-1.566-1.19-1.566-.973-.665.075-.651.075-.651 1.076.076 1.642 1.103 1.642 1.103.956 1.638 2.507 1.165 3.117.89.097-.691.373-1.165.68-1.432-2.38-.27-4.88-1.19-4.88-5.283 0-1.168.42-2.123 1.104-2.872-.11-.27-.48-1.358.104-2.83 0 0 .902-.288 2.95 1.097.86-.24 1.78-.36 2.7-.365.92.005 1.84.125 2.7.365 2.05-1.385 2.95-1.097 2.95-1.097.584 1.472.214 2.56.104 2.83.687.749 1.104 1.705 1.104 2.872 0 4.1-2.503 5.01-4.89 5.273.384.332.727.987.727 1.99 0 1.435-.015 2.594-.015 2.948 0 .287.19.623.737.517C18.683 19.74 21.75 15.735 21.75 11c0-5.927-4.823-10.75-10.75-10.75z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.faa57f268bc41168b009641cb91b6853.svg";
export { ForwardRef as ReactComponent };